export function shouldPresentTraditionSelectorOnEntry(search: string, pathname: string) {
  const params = new URLSearchParams(search)
  if (['dataset', 'mode', 'focus', 'story', 'timeline', 'collection'].some((key) => params.has(key))) return false
  return !/^\/(?:en|zh-hant)\/(?:greek|norse)(?:\/|$)/i.test(pathname)
}
